(function () {
  const instances = new WeakMap();

  function initTuyaBackToTop(section) {
    if (!section || instances.has(section)) return;

    const btn = section.querySelector('.tuya-back-to-top-btn');
    const wrapper = section.querySelector('.tuya-back-to-top-wrapper');
    if (!btn || !wrapper) return;

    const clickHandler = function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    btn.addEventListener('click', clickHandler);

    const threshold = parseInt(section.getAttribute('data-threshold'), 10) || 300;

    const sentinel = document.createElement('div');
    sentinel.className = 'tuya-back-to-top-sentinel';
    sentinel.style.position = 'absolute';
    sentinel.style.top = `${threshold}px`;
    sentinel.style.left = '0';
    sentinel.style.width = '1px';
    sentinel.style.height = '1px';
    sentinel.style.pointerEvents = 'none';
    sentinel.style.visibility = 'hidden';
    
    document.body.appendChild(sentinel);

    const observerOptions = {
      root: null,
      threshold: 0
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(entry => {
        const isScrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        if (isScrolledPast) {
          wrapper.classList.add('is-visible');
        } else {
          wrapper.classList.remove('is-visible');
        }
      });
    }, observerOptions);

    observer.observe(sentinel);

    instances.set(section, {
      destroy: function () {
        btn.removeEventListener('click', clickHandler);
        observer.disconnect();
        if (sentinel.parentNode) {
          sentinel.parentNode.removeChild(sentinel);
        }
        instances.delete(section);
      }
    });
  }

  function destroyTuyaBackToTop(section) {
    const instance = instances.get(section);
    if (instance) {
      instance.destroy();
    }
  }

  function initAllTuyaBackToTops(root) {
    const scope = root || document;
    const targets = [];
    
    if (scope.matches && scope.matches('[data-tuya-section="back-to-top"]')) {
      targets.push(scope);
    }
    
    const elements = scope.querySelectorAll('[data-tuya-section="back-to-top"]');
    elements.forEach(el => targets.push(el));

    targets.forEach(initTuyaBackToTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", function () {
      initAllTuyaBackToTops(document);
    });
  } else {
    initAllTuyaBackToTops(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllTuyaBackToTops(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section = event.target.matches && event.target.matches('[data-tuya-section="back-to-top"]')
      ? event.target
      : event.target.querySelector('[data-tuya-section="back-to-top"]');
    if (section) destroyTuyaBackToTop(section);
  });
})();
